export const loginRtkKey = 'login';
export const simpleCreateUserRtkKey = 'simpleCreateUser';
export const simpleUpdateUserRtkKey = 'simpleUpdateUser';

export const getCouponListRtkKey = 'getCouponList';

export const forgotPasswordRtkKey = 'forgotPasswordSendOtp';

export const signupRtkKey = 'signup';

export const sendOtpToPhoneRtkKey = 'sendOtpToPhone';

export const verifyMobileOtpRtkKey = 'verifyMobileOtp';

export const getPhoneCodeRtkKey = 'getPhoneCode';

export const verifyOtpRtkKey = 'verifyOtp';

export const getEventListRtkKey = 'getEventList';

export const getServiceTypesRtkKey = 'getServiceTypes';

export const getCargoTypesRtkKey = 'getCargoTypes';

export const getCarriersRtkKey = 'getCarriers';

export const createEnquiryRtkKey = 'createEnquiry';

export const deleteEnquiryRtkKey = 'deleteEnquiry';

export const submitDraftRtkKey = 'submitDraft';

export const resetPasswordRtkKey = 'resetPassword';

export const resendOtpRtkKey = 'resendOtp';

export const updateDetailsRtkKey = 'updateDetails';

export const getProfileRtkKey = 'getProfile';

export const getTrackingListRtkKey = 'getTrackingList';

export const getReturnTrackingListRtkKey = 'getReturnTrackingList';

export const refreshTrackingStatusRtkKey = 'refreshTrackingStatus';

export const getShippingTrackingDetailsRtkKey = 'getShippingTrackingDetails';

export const getReturnTrackingDetailsRtkKey = 'getReturnTrackingDetails';

export const downloadBundleRtkKey = 'downloadBundle';

export const getOrganisersListRtkKey = 'getOrganisersList';

export const getStandTypesRtkKey = 'getStandTypes';

export const getDimensionsListRtkKey = 'getDimensionsList';

export const getWeightsListRtkKey = 'getWeightsList';

export const validateOrganiserPasscodeRtkKey = 'validateOrganiserPasscode';

export const initiatePaymentRtkKey = 'initiatePayment';

export const checkPaymentStatusRtkKey = 'checkPaymentStatus';

export const getPaymentListRtkKey = 'getPaymentList';

export const getPaymentDetailsRtkKey = 'getPaymentDetails';


export const adminGetFeedbacksRtkKey = 'adminGetFeedbacks';

export const adminGetEventListRtkKey = 'adminGetEventList';

export const adminEventShowDashboardRtkKey = 'adminEventShowDashboard';

export const createLabelRtkKey = 'createLabel';

export const adminGetEnquiriesListRtkKey = 'adminGetEnquiriesList';
export const getEnquiryListSimpleRtkKey = 'getEnquiryListSimple';

export const getAllOrganisersListRtkKey = 'getAllOrganisersList';

export const getAllEventsListRtkKey = 'getAllEventsList';

export const getAllExhibitorsListRtkKey = 'getAllExhibitorsList';

export const getExhibitorListRtkKey = 'getExhibitorList';

export const getEnquiryByIdRtkKeyV2 = 'getEnquiryByIdV2';

export const getEnquiryMetaRtkKey = 'getEnquiryMeta';

export const updateEnquiryMetaRtkKey = 'updateEnquiryMeta';

export const updateEnquiryRtkKeyKey = 'updateEnquiry';

export const adminGetWHListRtkKey = 'adminGetWHList';

export const updateAdminWHRtkKey = 'updateAdminWH';

export const createAdminWHRtkKey = 'createAdminWH';

export const createAdminEventRtkKey = 'createAdminEvent';

export const updateAdminEventRtkKey = 'updateAdminEvent';

export const createAdminOrganiserRtkKey = 'createAdminOrganiser';

export const updateAdminOrganiserRtkKey = 'updateAdminOrganiser';

export const getTeamListRtkKey = 'getTeamList';
export const createCarrierRtkKey = 'createCarrier';
export const addTeamRtkKey = 'addTeam';
export const deleteTeamRtkKey = 'deleteTeam';
export const updateTeamRtkKey = 'updateTeam';

export const getMemberListRtkKey = 'getMemberList';
export const addMemberRtkKey = 'addMember';
export const updateMemberRtkKey = 'updateMember';
export const softDeleteMemberRtkKey = 'softDeleteMember';
export const generateManifestRtkKey = 'generateManifest';

export const processFormWithAutoFormCreationRtkKey = 'processFormWithAutoFormCreation';
export const generateExcelRtkKey = 'generateExcel';
export const adminDashboardRtkKey = 'adminDashboard';
export const getAdminFMDashboardRtkKey = 'getAdminFMDashboard';

/** `card` query param values for `GET /admin/fm/dashboard` (targeted partial refresh). */
export const FM_CARD = {
  operationsPickupsToday: 'operations_pickups_today',
  operationsPickupsInTransit: 'operations_pickups_in_transit',
  operationsPickupsPending: 'operations_pickups_pending',
  operationsMissed: 'operations_missed',
  returnsPickupsToday: 'returns_pickups_today',
  returnsPickupsInTransit: 'returns_pickups_in_transit',
  returnsPickupsPending: 'returns_pickups_pending',
  returnsMissed: 'returns_missed',
  showsCountryWise: 'shows_country_wise',
  showsShows: 'shows_shows',
  carriersOutbound: 'carriers_outbound',
  adminMissingDetails: 'admin_missing_details',
} as const;

export type FmCardKey = (typeof FM_CARD)[keyof typeof FM_CARD];

export const saveDashboardLayoutRtkKey = 'saveDashboardLayout';
export const saveAdminFmLayoutRtkKey = 'saveAdminFmLayout';

export const genManifestJSONRtkKey = 'genManifestJSON';
export const createEnqJSONRtkKey = 'createEnqJSON';